import { concat } from "lodash";

export default {
  system: {
    title:
      "Shanghai Xiaolong Technology Co., LTD-Xiaolong Technology-Automotive aftermarket intelligent supply chain service platform-authentic auto parts circulation service platform",
    home: {
      // header
      concact: {
        em: "login",
      },
      // meau
      menu: {
        home: "Home",
        Product_Center:
          "Product",
        aboutUs: "About Us",
        companyIntroduction:
          "Company Profiles",
        qualityControl:
          "Quality Control",
        efficient:
          "Efficient Operation",
        digital:
          "Digital Service",
        marketing:
          "Marketing Support",
        partner:
          "NewBusinessPartnership",
        social:
          "SocialResponsibility",
        news: "News",
        mediaCenter:
          "Media Center",
        contactUs:
          "Contact Us",
        contactWay:
          "Contact Way",
        register: "Register",
        talentPlan:
          "Talent Plan",
        // 其他菜单项...
      },
      // product
      product: {
        chanpin:
          "product name:",
        oE: "OE:",
        pinpai: "brand:",
        chexing: "category:",
        carType:
          "Applicable models:",
      },
      //lunbo
      placeholder:
        "Please enter the product name...",
      text: "Search and Make your xiao Long parts catalogue",
      p_t: "Professional service, customer first",
      w_z_t:
        "Watch the full version",
      // --q_o
      a_t_o:
        "Xiaolong Technology is located in the Tongji Auto Park, Jiading District, Shanghai. It is committed to building a leading domestic auto aftermarket service platform. It is customer - centred, driven by digital sales capabilities, supported by a smart AI - based commercial operations platform, and focuses on the R & D of auto - parts transactions and Internet - based e - commerce services.",
      a_t_t:
        "With professional knowledge and an innovative spirit, Xiaolong Technology has used technical components as a starting point. It has successfully integrated high - quality resources across the industry chain and formed close partnerships with core Tier 1 factories and automakers upstream.The company has developed an online self - operated mall and has a strong offline network of over 30,000 dealers nationwide, including 1,600 active ones.",
      a_t_p:
        "Xiaolong Technology combines online and offline approaches to serve the entire channel of China's auto aftermarket customers. With an innovative business model and strong operational capabilities, it injects new vitality into enterprise development.",
      a_t_q:
        "Looking ahead, Xiaolong Technology will continue to embrace the philosophy of 'technology - driven, innovation - led, and customer - first'. It will keep enhancing its platform functions and service experience, promoting digital transformation and high - quality development in the auto aftermarket industry, and steadily advancing towards its vision of creating an auto aftermarket service platform that everyone relies on.",
      g_d: "more",
      // --q_t
      v_t: " Shanghai Xiaolong Technology Co., Ltd. is a high-tech and specialized enterprise in Shanghai. The wholly-owned subsidiary, Shanghai Automotive Parts Industry Joint Co., Ltd., was established in 1993 and has been deeply involved in the Chinese automotive aftermarket for 30 years. It is a benchmark enterprise in the Chinese automotive aftermarket. Xiaolong Technology has established strategic partnerships with over 100 OEM and TIER1 manufacturers, providing you with integrated after-sales automotive parts supply solutions for more than 40 brand car models, including SAIC Volkswagen, SAIC General Motors, SAIC Passenger Cars, FAW Volkswagen, FAW Audi, Mercedes Benz, BMW, Land Rover, Great Wall, etc.",
      // mask
      hlp_title: "HUALIANPEI",
      brand_title:
        "Brand Matching",
      des_t:
        "Amoser Timing System Professional Brand",
      des_b:
        "Zhongyi serves customers with high-quality products",
      //dongtu
      tu_yc: {
        o_a: "原厂件",
        o_b: "原厂件",
      },
      tu_sj: {
        o_a: "Huayu visual headlights",
        o_b: "The light of dream-chasing wisdom illuminates wonderful travel",
      },
      tu_o: {
        o_a: "Dongan Power engine",
        o_b: "The engine is a masterpiece of technology, a product of innovation and tenacity",
      },

      tu_t: {
        o_a: "Huayu Three Electric Compressor",
        o_b: "Strong and durable 'core' that can withstand the test of time",
      },
      tu_th: {
        o_a: "Daily Youjie Electronic Fan",
        o_b: "Let the world be refreshing, refreshing between heaven and earth",
      },
      tu_qr: {
        o_a: "Chery engine",
        o_b: "Engines are masterpieces of technology, the result of innovation and tenacity.",
      },

      // tu_f: {
      //   o_a: "Continental fuel pump",
      //   o_b: "Power comes from technology, good pumps achieve dreams",
      // },
      // tu_fi: {
      //   o_a: "BorgWarner Supercharger",
      //   o_b: "Turbocharged, full of power, making driving easier",
      // },
      //--zhiliang
      m_p: "Xiaolong Technology takes quality as its brand life, which means we can always provide you with the highest product quality and fully guarantee your market reputation. At the same time, we promise that the products provided by Xiaolong's cooperative brands have passed international safety and quality certification, with a maximum warranty period of up to 4 years.",
      //--cp
      inner_1: "04-02.2024",
      inner_2: "03-28,2024",
      inner_3: "03-26,2024",
      jq: "What is the function of the intake manifold?",
      qj: "What is the front reduced plane bearing of a car?",
      ry: "What are the functions of the fuel pump assembly?",
      // --yq
      you_qing:
        "Friendship link",
      lianjie: {
        text_a:
          "Product Center",
        text_news:
          "News Center",
        text_b: "About Us",
        text_c: "contact us",
        a_a: "",
        a_b: "",
        a_c: "",
        a_d: "",
        a_f: "",
        a_g: "",
        a_h: "",
        a_i: "",
        a_j: "Company Introduction",
        a_k: "Quality Control",
        a_l: "Efficient operation",
        a_m: "Digital Service",
        a_n: "Marketing Support",
        a_o: "New Business Partnership",
        a_p: "Social Responsibility",
        a_q: "Contact Details",
        a_r: "Register",
        a_t: "Talent Plan",
        a_u: "Message",
      },
      icon: {
        qr_text:
          "Scan QR code to follow us",
      },
      footer: {
        text: "Copyright ©2024 xiao all rights reserved",
        // text_a:"Shanghai Public Network Security: 31011402009884",
        // text_b:"Hu ICP Bei 2022019894-1",
        text_a:
          "沪公网安备：31011402009884",
        text_b:
          "沪ICP备2022019894号-1",
        f_text_o:
          "Website Map",
        f_text_t:
          "Privacy protection",
        f_text_th:
          "Terms of Use",
        f_text_f:
          "Legal Statement",
      },
    },
    brand: {
      intro_text:
        "Since its establishment, HLP brand has been a professional supplier of ŠKODA auto parts, focusing on serving ŠKODA after-sales maintenance vehicles with over 20 years of experience.",
      intro_detail:
        "Currently, HLP brand can provide more than 15,000 products for ŠKODA models. Meanwhile, HLP new products are launched in sync with ŠKODA's new vehicle releases. All these make HLP brand the most reliable partner in ŠKODA's after-sales market in more than 70 countries worldwide.",
    },
    about: {
      company: {
        inner_h:
          "Your most trusted partner",
        main_dt:
          "OEM Tier 1 upstream resources, sales network all over the country",
        main_db:
          "With 100 + city partners (front warehouse) covering 1600 + strategic dealers, service 400,000 + end point repair shop",
        textBox_o:
          "Xiaolong Technology Service Platform: Focused on the integration of genuine OEM parts and Tier 1 supplier equivalent parts for original equipment manufacturers. Ensuring traceability, it benefits automotive aftermarket service dealers and regular car users alike. ",
        textBox_t:
          "Xiaolong is dedicated to customer success as its mission, committed to innovation, and focused on providing customers with professional products and services that continually exceed their expectations. Meanwhile, with an open and collaborative attitude, Xiaolong is devoted to achieving win-win outcomes with all business partners.",
        oba: "Corporate Mission",
        oca: "Driven by technological innovation, to create an efficient, transparent, andtrustworthy automotive aftermarket supply chain ecosystem",
        oda: "Committed to providing efficient solutions for automotive aftermarket service dealers through technological innovation and resource integration, empowering their business growth; at the same time, creating a transparent, convenient and high-quality automotive service experience for ordinary automotive users, and building a win-win ecosystem from supply chain to end point consumers",
        obb: "Corporate Vision",
        ocb: "To build a smart supply chain service platform for the automotive aftermarket, achieving efficient integration of end-to-end information flow, logistics, and capital flowthrough advanced digital infrastructure and rich data accumulation",
        odb: "We are committed to building a smart supply chain hub for the entire automotive aftermarket. Relying on AIoT (Artificial Intelligence of Things) and blockchain technologies, we establish a new generation of digital foundation, deeply integrating the needs of suppliers, channel partners, service terminals, and vehicle owners. We have connected the full-link closed loop that ranges from the traceability of component production, intelligent warehouse scheduling, precise logistics distribution to terminal service response.",
        obc: "Corporate Concept",
        occ: "Guarantee of genuine product traceability, building the cornerstone of trust in the automotive aftermarket",
        odc: "The company adopts the F2B business model, directlyconnected to the factory, eliminating intermediate links to ensure that every product can betraced and is an original authentic product. Through technological empowerment, the company promotes data standardization, product standardization, and process standardization, assisting in the construction of industry credit systems, with the aim of becoming a leader and developer of data, service, credit, and quality standard systems for the entire industry chain.",
        obd: "Core Values",
        ocd: "Taking integrity as the foundation, being driven by innovation, putting customers first, and achieving win-win cooperation.",
        odd: "Adhere to honest operation and ensure that every product is genuine and traceable. Encourage technological innovation, model innovation, and service innovation, and continuously enhance the competitiveness of the enterprise. Establish long-term and stable cooperative relationships with upstream and downstream partners to achieve mutual benefit and win-win results. Be guided by customer needs and provide personalized and customized solutions.",
        obe: "social responsibility",
        oce: "Caring for the environment, giving back to society, and caring for employees",
        ode: "Establish career development dual channels (technical/management), provide full health insurance and mental health care; establish an innovation incubation fund to encourage employees to turn proposals into practical results",
      },
      quality: {
        inner_h: "Zhong Yi",
        main_d:
          "Product traceability  quality guaranteed",
        tit: " Jingjiang Zhongyi is a well-known Tier 1 supporting factory in China, with core products including various door lock blocks, locking devices, and other products, mainly for supporting the public. Zhongyi Auto Parts is a car lock brand specially crafted by Jingjiang Zhongyi Factory for the aftermarket. The car lock products cover a full range of Volkswagen models, as well as some popular models from other brands.",
        right:
          "With an annual production capacity of 1 million sets, Zhongyi has successively obtained quality system certifications such as ISO9001 and ISO/TS16949, ensuring the quality of all aspects from raw materials entering the factory, products leaving the factory, to after-sales service. It is highly trusted by users.",
        item_a:
          "Volkswagen's full range",
        item_b:
          "Luxury car series",
        item_c:
          "New energy series",
      },
      efficient: {
        inner_h:
          "Efficient operation",
        main_d:
          "Serving global customers",
        text: "Make sure the order is delivered on time, only for better customer achievement",
        inner_t:
          "The company's warehouse is equipped with highly customized advanced digital control systems to ensure accurate supply and timely delivery.",
        inner_b:
          "Xiaolong is a modern logistics and warehousing center located in Shanghai, China, with a storage area of 4799m ² and a stock of over 30000 types.",
        wrap_text:
          "We have built an accurate, fast and complete customer order fulfillment management system through the ERP system, ensuring the on-time delivery of every customer's order, while maximizing the satisfaction of customers' diverse customization needs.",
      },
      digital: {
        inner_h:
          "Highly digitized",
        main_d:
          "Make your work more convenient",
        zaixian:
          "Xiaolong Online Ordering Platform",
        dinghuo:
          "Order anytime, anywhere, worry free!",
        we: "We have developed a customized Xiaolong online ordering platform based on customer needs and business models.",
        kehu: "Customers can achieve comprehensive order management through this platform, including product inquiry, product ordering, order tracking, event management, and interactive sharing.",
        dianzi:
          "Xiaolong Electronic Catalog",
        chanpin:
          "Easily create your Xiaolong product catalog",
        mulu: "You can easily find the products you want to know about in the electronic catalog of Xiaolong's website through a variety of intelligent search methods.",
        guanli:
          "Product Data Management",
        shuju:
          "TecDoc is the world's leading data provider",
        youxiu:
          "Xiaolong has been selected as the world's best data supplier by TecDoc for many consecutive years",
        quanche:
          "As a supplier of complete vehicle parts, we are fully aware of the importance of accuracy, completeness and professionalism of product data to customers' internal applications and even local operations.",
        zhuanye:
          "Xiaolong has a professional product data management team that organizes and outputs product data according to different product systems and continuously improves and updates it. At the same time, in order to facilitate customer ordering and save time, we also automatically match the related product information of a specific product, so that you can query it at a glance and make necessary choices.",
      },
      social: {
        inner_h:
          "Outside the industry",
        main_d:
          "Creating value for society",
        inner_t:
          "Xiaolong values corporate social responsibility and is willing to set an example for the Chinese automotive parts market",
        inner_b:
          "The company is not only committed to improving efficiency within its internal operators, but also focuses on the integration of genuine components from original OEMs and primary suppliers of OEMs, ensuring traceability and benefiting automotive aftermarket service dealers and ordinary automotive users.",
        left: "Xiaolong has great aspirations and is willing to build the company's operational model into an industry benchmark; Integrity, integrity, and compliance, Xiaolong sets an example for the Chinese automotive aftermarket.",
      },
      marketing: {
        inner_h:
          "Comprehensive marketing support",
        main_d:
          "Accurately meeting the personalized needs of customers",
        left_h:
          "Professional marketing support, working together with customers to create the future",
        b_o: "Xiaolong provides customers with traceable and high-quality original engine parts, as well as homogeneous parts from the first tier supplier of the engine factory. we assist customers in conquering the automotive parts market and jointly creating the future.",
        b_t: "Xiaolong provides customers with differentiated and competitive marketing solutions to help them deeply cultivate the market and stand firm in the market.",
        b_th: "Xiaolong provides practical preferential policies in the market, allowing customers to gain tangible benefits while increasing their performance.",
        f_r_t:
          "Policy incentives implemented in practice",
        b_fi: "Based on the basic idea of co creation and win-win, Xiaolong designs policies for customers. In addition to ensuring stable profit margins and returns, it can also alleviate the financial pressure on customers and assist them in improving in all aspects without blind spots.",
        b_s: "The preferential policies provided by Xiaolong to customers are implemented in all aspects, taking into account market share, profit margin, and sustainable development, making it a leading cooperation model in the Chinese automotive aftermarket.",
      },
      partner: {
        inner_h:
          "Beyond cooperation",
        main_d: "We do more",
        tl: "Establish a flexible and efficient information sharing mechanism with customers, respond quickly to the rapidly changing market, and work together with customers to create a win-win situation",
        tr: "Dedicated to meeting personalized policy and order needs of customers",
        bl: "By utilizing high-end and comprehensive upstream resources, we can meet the needs of our customers for segmented markets and empower them to break through and grow",
        br: "Xiaolong has established mature and stable cooperative relationships with upstream suppliers to help them establish a solid foundation in the increasingly fierce automotive aftermarket and create a better future together",
      },
    },
    contact: {
      register: {
        s_y: "Home",
        zhu_ce: "Register",
        title: "Message",
        intro:
          "We are looking forward to hearing more about you and your project. We are currently taking on new projects. Feel free to fill out the contact on this page or email us directly. Cheers!",
        text_p:
          "We value the privacy of all visitors and assure you that we will strictly use this information to serve you, Please refer to our privacy policy for details.",
        name: "Name:",
        company:
          "Company Name:",
        country: "Country:",
        city: "City:",
        address: "Address:",
        mobile:
          "Mobile phone:",
        email: "Email:",
        type: "Business type:",
        t_w: "Wholesaler",
        t_r: "Retailers",
        t_t: "Trade agency, organization",
        about:
          "How do you know about us:",
        search:
          "Search engines such as Baidu, Google",
        others:
          "Introduction by Others",
        look: "I have seen Xiaolong's products, but I have never bought them",
        buy: "I have purchased Xiaolong products before",
        promotion:
          "Exhibition promotion",
        agree:
          "I agree to Xiaolong's usage conditions and privacy policy terms.",
        code: "Verification code:",
        password: "Password:",
        confirmpassword:
          "Confirm password:",
        description:
          "Describe your business:",
        primary: "Submit",
        rules: {
          name: {
            pattern:
              "Please enter the correct name",
            required:
              "Please enter your name",
            length:
              "Between 3 and 15 characters in length",
          },
          company: {
            pattern:
              "Please enter the correct company name",
            required:
              "Please enter the company name",
            length:
              "Between 3 and 15 characters in length",
          },
          mobile: {
            pattern:
              "Please enter the correct phone number format",
            required:
              "Phone number/account cannot be empty",
            length:
              "Between 1 and 11 characters in length",
          },
          country: {
            pattern:
              "Please enter the correct country name",
            required:
              "Please enter the country name",
            length:
              "Length between 2 and 10 characters",
          },
          email: {
            pattern:
              "Please enter the correct email format",
            required:
              "Email cannot be empty",
          },
          password: {
            pattern:
              "6-20 characters can be English letters, numbers, or symbols (excluding spaces), with a minimum of two types among letters, numbers, and punctuation marks",
            required:
              "The password cannot be empty",
          },
          confirmpassword: {
            required:
              "Confirm that the password cannot be empty",
          },
          description: {
            required:
              "Requirement note cannot be empty",
          },
        },
      },
      contactWay: {
        g_s: "Xiaolong Technology Co., Ltd.Shanghai ",
        dizhi:
          "Address: No. 9, Lane 1300, Xiechun Road, Anting Town, Jiading District, Shanghai",
        youbian:
          "Postal Code: 201804",
        phone:
          "Phone: 021-6358 1508",
        email:
          "Email:{email}",
        hg_s: "Xiaolong Technology Co., Ltd.Henan ",
        hdizhi:
          "Address: No. 15, Row 6, Zone A, Yabang Auto Parts City, Zhengzhou City.",
        hyoubian:
          "Postal Code: 100097",
        hphone:
          "Phone: 0371-6632 4566",
        hemail:
          "Email:{hemail}",
        guanzu:
          "Follow us for more interaction and engagement.",
      },
    },
    map: {
      news: "News Center",
      mediaCenter:
        "Media Center",
      more: "More",
      latestNews:
        "Latest News",
    },
    productList:
      "Product List",
    // privacy
    privacy: {
      head_text:
        "Privacy Protection",
      s_1: "1. Information We Collect",
      s_2: "2. Protecting Your Privacy",
      s_3: "3. Privacy Principles",
      s_4: "4. Use of Cookies",
      b_1: "You may normally visit our website and acquire information on anonymous status. Some resources, however, are only accessible upon registration. We will explain the purpose of the information prior to asking from you. In normal conditions, the registration requires some basic information and contact number of you or your company. The reasons are to better understand your demands, contact you promptly so as to offer effective services.",

      b_2: "We will apply proper measures to protect your privacy. Upon your providing sensitive information to us, we would apply reasonable steps to protect your sensitive information; we will also use reasonable safety measures to store information of you and your company. We shall not reveal any of your private information to the irrelevant part (corporation or individual) without your permission unless in the condition of compulsory regulations by law or government. However, we shall provide your name and address to the third party, such as any transportation company, if you ask us to provide specific customer supporting services or send objects to you.",
      b_3: "As your privacy is of utmost importance to us, hence, Xiaolong shall administer information concerning privacy according to the three following policies.",

      b_4: "Principle 1:",
      b_5: "Xiaolong shall clearly ask for the information of individual and corporation once it needs to confirm your identification and contact. Under some possible circumstances, Xiaolong shall utilize some means to confirm the correctness and timeliness of your personal information.",

      b_6: "Principle 2:",
      b_7: "Xiaolong shall probably publicize personal information due to legal requirements, or confirm the necessity of the following manners for their goodwill:",
      b_8: "(1)According with legal notice or follow the legal procedures adapted to Xiaolong website;",
      b_9: "(2) Protecting the rights or property of Xiaolong's customers;",
      b_10: "(3)For the sake of protecting individual or public security of Xiaolong and its customers under emergency.",

      b_11: "Principle 3:",
      b_12: "If you ever feel that Xiaolong hasn't followed these principles, please inform us via email at {hemail} We'll do our best to promptly address and rectify the issue within a reasonable and appropriate scope.",
      b_13: "Xiaolong website shall use cookies sometimes to determine which web pages enjoy the highest popularity with the purpose of providing you with better services upon your visit. Cookies do not trace personal information. We may use cookies upon your registration. Under these circumstances, useful information shall be stored as the website may identify your status at your next visit. Those cookies from Xiaolong website can only be read by its website. You can also visit most web pages of our website even if your browser is set at rejecting cookies.",
    },
    //clause
    clause: {
      head_text:
        "Terms of use",
      s_1: "1. Scale",
      s_2: "2. Website Content of XiaoLong",
      s_3: "3. Use Right",
      s_4: "4. Intellectual property rights",
      s_5: "5. Registered and Used by Web Pages under Protection",
      s_6: "6. Quote & Links",
      s_7: "7. Disclaimer of liability of ownership, quality, virus and other deficiency",
      s_8: "8. Use Obligation",
      s_9: "9. Protection of Individual Data",
      p_1: " 1.1  Users shall absolutely follow the conditions of use of the websites provided by XiaoLong except for related laws issued by Chinese government. Upon start, users shall accept the effective and the latest use conditions.",
      p_2: "1.2  The common condition of use, in specific cases such as business of product and/or services, shall be complemented, amended or replaced by further condition.",
      p_3: "XiaoLong places unbounded information without any promise conditions and files and software of unprotected integration for adjustment and download on its website. XiaoLong is capable of suspending the website or changing content completely or partially without any notice in advance. Based upon characteristics of the Internet and computers, XiaoLong does not undertake the responsibility of discontinue availability of its website.",
      p_4: "3.1  The use of information, software and files acquired from XiaoLong website is restricted by the provisions. The use shall comply with the applicable conditions of permission agreed by XiaoLong. The conditions of permission from concrete negotiation are superior to this provision.",
      p_5: "3.2  XiaoLong authorizes users non-exclusive and inalienable rights, which permits use of information, software and files acquired from XiaoLong’s website.",
      p_6: "3.3  Software in read-only condition is provided freely. Users demands for right of opening any source code does not exist.",
      p_7: "3.4  Users, at any time, shall not release information, software or files to the third party through means of sales, rent or others. Users shall not develop or translate software reversely or provide to the third party if there are reversed regulations in non-related-laws. Users shall make a copy of the software if it’s based for use conditions.",
      p_8: "3.5  The information, software and files are protected by copyright law, international copyright agreement and laws and regulations concerning IPR. Users shall comply with related laws, shall not erase any certification of tests and numbers, labels or copyright notice on information, software, files or copies.",
      p_9: "4.1  Without written permission from XiaoLong in advance, any information, label and website content concerning XiaoLong shall not be changed, copied, reproduced, distributed, leased, utilized, complemented or used through any means",
      p_10: "4.2  Except for use right and other rights clearly authorized, users are not offered rights through any other forms, especially for corporate name or right about industrial property, such as patent, utility model or right of labels. XiaoLong does not have the obligation to authorize the rights mentioned above.",
      p_11: "5.1  Some of the web pages of XiaoLong’s website, protected through means of password, are exclusively accessible to registered users. Registration at XiaoLong website does not create any rights. Specifically, XiaoLong retains the rights in advance that allowed the registered users to browse freely. XiaoLong, without providing any reasons at any time, revokes access rights through means of encrypting visiting data, especially under such circumstances as users’ provision of wrong registration information, violating the prudential obligations of use conditions or their processing the visiting data, applicable laws of visiting or using XiaoLong website, or un-using the website for long period.",
      p_12: "5.2  Upon registration, users shall provide accurate and right information, and notify the parties concerning any changes on timely manner. Users shall guarantee that the email address provided can receive and send the designated emails from the website.",
      p_13: "5.3  Users shall receive user’s name and password (users’ data) after approval since registration. Users shall guarantee that the users’ data will not be released to third party and bear the reasonability towards its utilization. After each visit of areas protected by password, users shall quit the web page. Users shall immediately notify XiaoLong through email on condition that acknowledging the third party is misusing users’ data. After receiving the notification , XiaoLong shall re-set passwords and inform users after approval.",
      p_14: "5.4  Users shall ask to delete any registration through written forms at any time, as long as the information is forbidden in the current contracts. Under conditions alike, XiaoLong shall immediately delete all those unneeded users’ data and related private information.",
      p_15: "The website of XiaoLong may contain quote and links (hyperlink) that lead to third websites. XiaoLong does not bear any responsibilities of content on these websites, XiaoLong shall not turn the content and information on any websites connected by these external linkages uncontrolled by XiaoLong in practice into its own content. Users themselves bear the responsibility only of utilizing linked websites.",
      p_16: "7.1  Except for intentional or deliberate acts, XiaoLong bears no responsibility in terms of deficiency responsibility about ownership, quality of information, software and files, especially the correctness, un-defect and rights existence, integration and availability on condition that the information, software and files are provided free of charge.",
      p_17: "7.2  The information of XiaoLong website may not contain information of explanation of possibility of product technology or common description at individual cases (such as reasons of product alteration). Hence, both sides shall accord with the performance explanation of products prior to purchase at individual cases.",
      p_18: "7.3  Xiaolong shall try its best to protect the website from any viruses; however, it can not guarantee the virus-free environment. Users shall adopt proper safety measures and virus scan prior to downloading any information, software or files with the purpose of protecting themselves and preventing virus from into website of Xiaolong.",
      p_19: "7.4  Burden of proof has no connection with any conditions mentioned above.",
      p_20: "8.1  Users shall not perform following acts towards XiaoLong website",
      p_21: "• Creating damage and injury or violating the privacy of anyone, especially adolescent",
      p_22: "• Violation of good customs through utilization",
      p_23: "• Violation of industrial property, copyright or other property rights",
      p_24: "• Sending any programmes may contain virus, Trojans or any contents may damage software",
      p_25: "• Providing, storing or sending forbidden hyperlink content, especially those hyperlinks or contents violate duty of confidentiality or being illegal",
      p_26: "• Sending advertisement or uninvited email (so-called spam), sending alert unconcerned with virus, malfunction or similar situation, inviting to participate into activities as gambling, snowball game, chain letter, pyramid system and others alike",
      p_27: "8.2  Xiaolong is capable of blocking those website users at any time, especially those who have violated the obligations under the terms. ",
      p_28: "XiaoLong shall comply with the applicable data protection rules accessible at its website upon editing, using and dealing with users’ individual information.",
    },
    statute: {
      head_text:
        "Legal Notice",
      p_1: "Person in Charge of Website Content",
      p_2: "Information Center - IT Department",
    },
    login: {
      placeholder:
        "Username or email address",
      password: "Password",
      jizhu: "Remember Me",
      button: "Log in",
      text: "Welcome to Tantivy",
      zhuce:
        "Register New Account",
    },
    talentPlan: {
      title: "Talent Plan",
      title_2:
        "Recruitment positions",
      p_1: "Shanghai Xiaolong Technology Co., Ltd. is a leading service-oriented supplier in China's automotive parts industry. It has two well-known independent after-sales brands, Zhongyi Auto Parts and Amos, as well as Tier 1 resources to support OEMs such as SAIC Volkswagen and SAIC General Motors. It focuses on the integration of genuine OEMs and homogeneous parts from OEMs' primary suppliers, providing high-quality and reliable original and homogeneous automotive parts for models such as Volkswagen, Audi, General Motors, Datong, and Roewe.",
      p_2: "The company is based on numerous upstream enterprises Tier The multi-dimensional advantages of 1 factory resource, rich product variety supply, strong market research and reverse development capabilities, and more than 3000 top distributor customers nationwide have enabled Xiaolong's products and influence to continue to expand, with customers covering all key cities and continuously improving in the Chinese automotive parts market.",
      p_3: "We are looking for partners who share the same values and development philosophy as Xiaolong Enterprise, working together to create the future. We look forward to your joining and welcome you to contact our recruitment department to learn about the current recruitment status for the positions we need.",
      p_4: "In addition to an enthusiastic and uplifting work atmosphere and a comfortable office environment, we also provide you with: five insurances and one fund, work lunch, career planning, regular training, and employee travel. Join Xiaolong and work together to create a bright future!",
      th_1: "Open positions",
      th_2: "Work location",
      fot_b:
        "Delivery method:",
      fot_d:
        "Name your resume as Name+Position and send it to your email. We will contact you as soon as possible!",
      hr: "HR contact email:",
      phone: "Phone:",
      dizhi: "Address:",
      can: "View details",
    },
    notFound: {
      title:
        "Sorry, the page you visited does not exist",
      backHome:
        "Back to Home",
    },
  },
};
